import { api, unwrap } from './client';

export function loginRequest(payload) {
  return unwrap(api.post('/api/auth/login', payload));
}

export function meRequest() {
  return unwrap(api.get('/api/auth/me'));
}

export function changePasswordRequest(payload) {
  return unwrap(api.post('/api/auth/change-password', payload));
}
